import React from 'react';
import { AlertCircle, RefreshCw, Home } from 'lucide-react';

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service like Sentry here
    console.error("GlobalErrorBoundary Caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', padding: '20px',
          textAlign: 'center', backgroundColor: '#f9fafb', fontFamily: 'system-ui, -apple-system, sans-serif'
        }}>
          <div style={{
            width: '80px', height: '80px', backgroundColor: '#fff7ed', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px',
            border: '1px solid #ffedd5'
          }}>
            <AlertCircle color="#fb923c" size={40} />
          </div>
          
          <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1f2937', marginBottom: '12px' }}>
            Hold on, let's catch our breath!
          </h1>
          
          <p style={{ color: '#6b7280', maxWidth: '400px', marginBottom: '32px', lineHeight: '1.6' }}>
            We hit a tiny speedbump in the application. Don't worry, nothing happened to your essential data—Likely just a fast network hiccup on our end! Take a sip of water and try giving it a quick refresh.
          </p>

          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#0d9488',
                color: 'white', fontWeight: 'bold', padding: '12px 24px', borderRadius: '8px',
                border: 'none', cursor: 'pointer', boxShadow: '0 4px 6px -1px rgba(13, 148, 136, 0.2)',
                transition: 'all 0.2s'
              }}
            >
              <RefreshCw size={18} /> Hard Refresh
            </button>
            <button
              onClick={() => window.location.href = '/'}
              style={{
                display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: 'white',
                color: '#4b5563', fontWeight: 'bold', padding: '12px 24px', borderRadius: '8px',
                border: '1px solid #d1d5db', cursor: 'pointer', transition: 'all 0.2s'
              }}
            >
              <Home size={18} /> Go To Home
            </button>
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default GlobalErrorBoundary;
